// dependencies
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Dialog3 as Dialog } from '@st-operations/uikit/src/v1/index.js'
import { BUTTON_THEME, Button, CHIP_TYPES, Chip, Pagination } from '@st-operations/uikit/src/v2'
import pretty from '@st-operations/uikit/lib/pretty'

export function removeAt(array, index) {
  return array.slice(0, index).concat(array.slice(index + 1))
}

const KEYWORDS_PER_PAGE = 50

const TopicAssociatedKeywordsModal = ({ open, onClose, topic, /*audience,*/ onConfirm }) => {
  const [keywords, setKeywords] = useState([])
  const [page, setPage] = useState(0)
  // const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (open && topic?.atoms?.keywords) {
      setKeywords(topic.atoms.keywords)
    }
  }, [open])

  // const handleExpandTopics = async () => {
  //   setLoading(true)
  //   const response = await expandTopics({
  //     query: topic.name,
  //     language: audience.languages.map((l) => l.value).join(','),
  //     regions: audience.regions.map((r) => r._id).join(','),
  //   })

  //   setKeywords([...new Set([...keywords, ...response.keywords])])
  //   setLoading(false)
  // }

  return (
    <Dialog open={open} close={onClose}>
      <div className="w-[600px]">
        <h3 className="font-medium text-gray-800 flex flex-row items-center justify-between gap-2">
          <div>Topic composition</div>
          <div className="border border-solid border-gray-400 text-gray-800 p-2 rounded text-sm font-bold">
            {topic?.keccType === 'kecc' ? 'KECC' : 'Keywords'}
          </div>
        </h3>
        <div className="mb-5 flex flex-row gap-2 flex-wrap">
          <For
            each="keyword"
            of={keywords.filter(
              (_, index) =>
                index >= page * KEYWORDS_PER_PAGE && index < (page + 1) * KEYWORDS_PER_PAGE
            )}
            index="index"
          >
            <Chip
              key={`${keyword}`}
              value={`${pretty(keyword)}`}
              onClick={() => setKeywords(removeAt(keywords, index))}
              small
              className="selected-keywords__chip"
              type={CHIP_TYPES.OUTLINE}
            />
          </For>
        </div>
        <If condition={keywords.length > KEYWORDS_PER_PAGE}>
          <Pagination
            className="justify-center mt-4 mb-4"
            options={new Array(Math.floor(keywords.length / KEYWORDS_PER_PAGE) + 1)
              .fill(0)
              .map((_, index) => index)}
            page={page}
            onPageChange={(page) => {
              setPage(page.value)
            }}
          />
        </If>
        <div className="flex flex-row justify-between border-0 pt-6 -mx-6 px-6 border-t border-solid border-gray-300">
          <Button className="m-0" theme={BUTTON_THEME.SECONDARY} onClick={onClose}>
            Cancel
          </Button>
          <div className="flex flex-row gap-4">
            <Button
              className="m-0"
              theme={BUTTON_THEME.PRIMARY}
              onClick={() => {
                onConfirm(keywords)
                onClose()
              }}
            >
              Confirm
            </Button>
          </div>
        </div>
      </div>
    </Dialog>
  )
}

TopicAssociatedKeywordsModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
}

TopicAssociatedKeywordsModal.defaultProperties = {
  open: false,
  onClose: () => {},
}

// export
export default React.memo(TopicAssociatedKeywordsModal)
